/**
 * Whether a garden center bought the container-garden add-on. Plantista
 * serialises `Retailer.feature_access` as enum VALUES (`container_garden`),
 * but compare case-insensitively so the NAME (`CONTAINER_GARDEN`) works too.
 */
export const CONTAINER_GARDEN_FEATURE = "container_garden";

export function hasContainerGarden(featureAccess: unknown): boolean {
  return (
    Array.isArray(featureAccess) &&
    featureAccess.some(
      (f) =>
        typeof f === "string" && f.toLowerCase() === CONTAINER_GARDEN_FEATURE
    )
  );
}
